"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var keyCodes_1 = require("../../../common/keyCodes");
var Tab_st_css_1 = require("./Tab.st.css");
var dataHooks_1 = require("../dataHooks");
exports.Tab = React.forwardRef(function (props, ref) {
    var _a;
    var index = props.index, item = props.item, onClick = props.onClick, isActive = props.isActive, indicateActive = props.indicateActive;
    var title = item.title;
    var onSelectTab = function () {
        onClick(index);
    };
    var onKeyDown = function (e) {
        var keyCode = e.keyCode;
        if (keyCodes_1.isSelectKey(keyCode)) {
            onSelectTab();
            e.preventDefault();
            return false;
        }
    };
    var dataAttributes = (_a = {},
        _a[dataHooks_1.TABS_DATA_KEYS.tabIndex] = index,
        _a[dataHooks_1.TABS_DATA_KEYS.tabIsActive] = isActive,
        _a);
    return (React.createElement("li", __assign({ ref: ref }, Tab_st_css_1.default('root', { isActive: isActive, indicateActive: indicateActive }, props), dataAttributes, { "data-hook": props['data-hook'], key: title + "-" + index, onClick: onSelectTab, onKeyDown: onKeyDown, tabIndex: 0, "aria-current": isActive }),
        React.createElement("span", { role: "link" }, title),
        React.createElement("div", { className: Tab_st_css_1.default.focusIndicatorWrapper, tabIndex: -1 },
            React.createElement("div", { className: Tab_st_css_1.default.focusIndicator, tabIndex: -1 }))));
});
//# sourceMappingURL=Tab.js.map